/**
 * Organization member roles.
 * Matches memberRoles in packages/db/src/schema/auth.ts
 */
export type OrganizationRole =
  // Legacy (generic orgs model).
  | "admin"
  | "member"
  | "owner"
  | "viewer"
  // Academy (Space Academy — organization layer).
  | "org_admin"
  | "campus_admin"
  | "teacher"
  | "staff"
  | "student"
  | "guardian";

export const ORGANIZATION_ROLES: OrganizationRole[] = ["admin", "member", "owner", "viewer"];

/**
 * Academy roles OFFERABLE when inviting (owner is excluded: it's assigned only
 * when creating the org). The backend validates against `auth::org_rbac::OrgRole`.
 */
export const ACADEMY_INVITE_ROLES: OrganizationRole[] = [
  "org_admin",
  "campus_admin",
  "teacher",
  "staff",
  "student",
  "guardian",
];

export function isOrganizationRole(role: string): role is OrganizationRole {
  return (ORGANIZATION_ROLES as readonly string[]).includes(role);
}
